import * as React from "react";
import { useMemo } from "react";
import { styled } from "@mui/material";
import { panelGroupToCaseGrouping, usePatientCase } from "./usePatientCase";
import { DataInputPanel } from "../dataInputTypes";
import { PatientCaseGrouping } from "../../context/diagnosticAgent";
import { DataInputPanelArea } from "../diagnosticAgent/editPatient/DataInputPanelArea";
//region [[ Styles ]]

const PatientDataInputViewContainer = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  overflowY: "hidden",
  alignItems: "stretch",
}));

//endregion [[ Styles ]]

//region [[ Props ]]

//endregion [[ Props ]]

//region [[ Functions ]]

//endregion [[Functions]]
const SectionConfiguration = {
  [PatientCaseGrouping.MAIN]: {
    title: "General",
    placeholder: "Risk Factor, Chronic Condition etc.",
  },
  [PatientCaseGrouping.BACKGROUND]: {
    title: "Background",
    placeholder: "Risk Factor, Chronic Condition etc.",
  },
  [PatientCaseGrouping.CLINICAL_FEATURES]: {
    title: "Physical Examination",
    placeholder: "Finding, Symptoms etc.",
  },
  [PatientCaseGrouping.REVIEW_OF_SYSTEMS]: {
    title: "Review Of Systems",
    placeholder: "Finding, Symptoms etc.",
  },
  [PatientCaseGrouping.WORKUP]: {
    title: "Workup",
    placeholder: "Test Results, Imaging etc.",
  },
};

export const PatientDataInputView = ({
  section,
  panels,
  categoryid, // subGroupId/panelId
  panelId,
  diagnose,
  loading,
  showTabs,
  onChangeSection,
  singlePanel,
  sectionTitle,
}: {
  section: PatientCaseGrouping;
  panels: Map<string, DataInputPanel>;
  categoryid?: string;
  panelId?: string;
  diagnose?: () => void;
  loading?: boolean;
  showTabs?: boolean;
  onChangeSection?: (section: PatientCaseGrouping) => void;
  singlePanel?: boolean;
  sectionTitle?: string;
}) => {
  const {
    handleChipAddMultiple,
    patientCase,
    doChangesToPatientCase,
  } = usePatientCase();

  const add = (qfs) => {
    handleChipAddMultiple(qfs, section);
  };

  // filter panels to correct section
  const sectionPanels = useMemo(
    () =>
      [...panels.values()].filter(
        (p) => panelGroupToCaseGrouping(p?.panelGroup?.id) === section,
      ),
    [panels, section],
  );

  const config = SectionConfiguration[section];

  return (
    <PatientDataInputViewContainer>
      <DataInputPanelArea
        loading={loading}
        title={config ? config.title : ""}
        add={add}
        changeCase={doChangesToPatientCase}
        section={section}
        categoryid={categoryid} // subGroupId rout->/:panelId?
        panelId={panelId}
        panels={sectionPanels}
        currentCase={patientCase}
        placeholder={config ? config.placeholder : ""}
        showSearchArea
        showTabs={showTabs}
        diagnose={diagnose}
        onChangeSection={onChangeSection}
        singlePanel={singlePanel}
        sectionTitle={sectionTitle}
      />
    </PatientDataInputViewContainer>
  );
};
